import 'hammerjs';

import { AfterViewInit, Component } from '@angular/core';

import { BaseComponent } from './_base/base.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends BaseComponent implements AfterViewInit {
  constructor() {
    super();
  }
  ngAfterViewInit() {
    this.checkLanguage();
  }
  checkLanguage() {
    if (localStorage.getItem('lang') === 'ar') {
      this.settings.rtl = true;
      this.translateService.use('ar');
    } else if (localStorage.getItem('lang') === 'en') {
      this.settings.rtl = false;
      this.translateService.use('en');
    } else {
      this.settings.rtl = false;
      this.translateService.use('en');
      localStorage.setItem('lang', 'en');
    }
  }
}
